import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromCost from '../reducers/cost.reducer';

import { selectSelectedMaterial } from './shared.selectors';
import { selectTechInputs } from './inputs.selectors';

/**
 * Every reducer module exports selector functions, however child reducers
 * have no knowledge of the overall state tree. To make them usable, we
 * need to make new selectors that wrap them.
 *
 * The createSelector function creates very efficient selectors that are memoized and
 * only recompute when arguments change. The created selectors can also be composed
 * together to select different pieces of state.
 */

export const selectCostState = createSelector(
  fromFeature.costState,
  (state) => state
);

export const selectSelectedCostPerUnit = createSelector(
  selectCostState,
  fromCost.selectSelectedCostPerUnit
);

export const selectConcreteRate = createSelector(
  selectCostState,
  fromCost.selectConcreteRate
);

export const selectMNDCRate = createSelector(
  selectCostState,
  fromCost.selectMNDCRate
);

export const selectplacingRate = createSelector(
  selectCostState,
  fromCost.selectplacingRate
);

export const selectlabourCost = createSelector(
  selectCostState,
  fromCost.selectlabourCost
);

export const selectConcreteSupplyPlaceEF = createSelector(
  selectCostState,
  fromCost.selectConcreteSupplyPlaceEF
);

export const selectReinforcementRate = createSelector(
  selectCostState,
  fromCost.selectReinforcementRate
);

export const selectFormworkRate = createSelector(
  selectCostState,
  fromCost.selectFormworkRate
);

export const selectFormworkEF = createSelector(
  selectCostState,
  fromCost.selectFormworkEF
);

export const selectStructuralSteelRateConcrete = createSelector(
  selectCostState,
  fromCost.selectStructuralSteelRateConcrete
);

export const selectStructuralSteelMassConcrete = createSelector(
  selectCostState,
  fromCost.selectStructuralSteelMassConcrete
);

export const selectStructuralSteelEFConcrete = createSelector(
  selectCostState,
  fromCost.selectStructuralSteelEFConcrete
);

export const selectPercentageOfAreaRequiringPT = createSelector(
  selectCostState,
  fromCost.selectPercentageOfAreaRequiringPT
);

export const selectPTEF = createSelector(selectCostState, fromCost.selectPTEF);

export const selectBallastRateConcrete = createSelector(selectCostState, fromCost.selectBallastRateConcrete);

export const selectBallastConcreteEF = createSelector(selectCostState, fromCost.selectBallastConcreteEF);

export const selectBallastRateSteel = createSelector(selectCostState, fromCost.selectBallastRateSteel);

export const selectBallastSteelEF = createSelector(selectCostState, fromCost.selectBallastSteelEF);

export const selectStructuralSteelRate = createSelector(
  selectCostState,
  fromCost.selectStructuralSteelRate
);

export const selectStructuralSteelEF = createSelector(
  selectCostState,
  fromCost.selectStructuralSteelEF
);

export const selectFactorySetup = createSelector(
  selectCostState,
  fromCost.selectFactorySetup
);

export const selectLaunchUnits = createSelector(
  selectCostState,
  fromCost.selectLaunchUnits
);

export const selectSiteMobilisation = createSelector(
  selectCostState,
  fromCost.selectSiteMobilisation
);

export const selectGeneralSiteCosts = createSelector(
  selectCostState,
  fromCost.selectGeneralSiteCosts
);

export const selectInsurance = createSelector(
  selectCostState,
  fromCost.selectInsurance
);

export const selectContractorRisk = createSelector(
  selectCostState,
  fromCost.selectContractorRisk
);

export const selectWeatherRisk = createSelector(
  selectCostState,
  fromCost.selectWeatherRisk
);

export const selectManagementSupervision = createSelector(
  selectCostState,
  fromCost.selectManagementSupervision
);

export const selectPlantEquipmentLaunch = createSelector(
  selectCostState,
  fromCost.selectPlantEquipmentLaunch
);

export const selectIndirectCostAssumptions = createSelector(
  selectCostState,
  fromCost.selectIndirectCostAssumptions
);

export const selectCostPageData = createSelector(
  selectCostState,
  selectSelectedMaterial,
  selectTechInputs,
  selectIndirectCostAssumptions,
  (state, material, techInputs, indirectCostAssumptions) => {
    return {
      state,
      material,
      techInputs,
      indirectCostAssumptions,
    };
  }
);
